export default __webpack_public_path__ + "static/joko-app-screenshot-home-fr-41e4395726d2e693ccdbd2564db36ec6.png";